import Vue from 'vue'
import Router from 'vue-router'
//首页
import Index from '../page/index/Index.vue'
import DP from '../page/dp/dp.vue'
import IndexNew from '../page/indexNew/indexNew.vue'
import IndexEasyVersion from '../page/indexEasyVersion/indexEasyVersion.vue'
import DpNew from '../page/dpnew/dpnew.vue'
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			redirect: '/Index'
		},
		{
			path: '/index',
			name: 'index',
			component: Index
		},
		{
			path: '/dp',
			name: 'dp',
			component: DP
		},
		{
			path: '/indexNew',
			name: 'indexNew',
			component: IndexNew
		},
		{
			path: '/indexEasyVersion',
			name: 'indexEasyVersion',
			component: IndexEasyVersion
		},
		{
			path: '/dpnew',
			name: 'dpnew',
			component: DpNew
		}
	] 
})


// WEBPACK FOOTER //
// ./src/router/index.js